module.exports = __webpack_public_path__ + "media/bundles/YoupiJob/assets/images/nb_hours_selection/Short-edda7bfb280eacd5fcf0fa12cd770821.svg";